import React from 'react';
import { TrendingUpIcon, DollarSignIcon, HomeIcon, RepeatIcon, LightbulbIcon } from 'lucide-react';
export function ProblemSolutionSection() {
  return <section className="py-16 bg-gradient-to-b from-white to-pink-50 px-4" data-id="element-159">
      <div className="container mx-auto max-w-6xl" data-id="element-160">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-161">
          Estás a un paso de cambiar tu vida
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-162">
          <div className="bg-white p-6 rounded-lg shadow-md border border-pink-100 hover:shadow-lg transition-all" data-id="element-163">
            <TrendingUpIcon className="h-10 w-10 text-pink-500 mb-4" data-id="element-164" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-165">
              Industria en crecimiento
            </h3>
            <p className="text-gray-600" data-id="element-166">
              La industria de las uñas es una mina de oro en constante
              expansión.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border border-pink-100 hover:shadow-lg transition-all" data-id="element-167">
            <HomeIcon className="h-10 w-10 text-pink-500 mb-4" data-id="element-168" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-169">Comienza desde casa</h3>
            <p className="text-gray-600" data-id="element-170">
              No necesitas local ni gran inversión para empezar tu negocio.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border border-pink-100 hover:shadow-lg transition-all" data-id="element-171">
            <DollarSignIcon className="h-10 w-10 text-pink-500 mb-4" data-id="element-172" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-173">Ingresos inmediatos</h3>
            <p className="text-gray-600" data-id="element-174">
              Puedes generar ingresos desde tu primera clienta.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border border-pink-100 hover:shadow-lg transition-all" data-id="element-175">
            <RepeatIcon className="h-10 w-10 text-pink-500 mb-4" data-id="element-176" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-177">Clientas recurrentes</h3>
            <p className="text-gray-600" data-id="element-178">
              Las clientas vuelven cada 2-3 semanas para mantenimiento.
            </p>
          </div>
        </div>
        <div className="bg-gradient-to-r from-pink-500 to-purple-600 p-6 md:p-10 rounded-xl text-white text-center" data-id="element-179">
          <LightbulbIcon className="h-12 w-12 mx-auto mb-4" data-id="element-180" />
          <h3 className="text-2xl font-bold mb-4" data-id="element-181">
            Pero nadie te enseña CÓMO lograrlo... hasta ahora.
          </h3>
          <p className="text-lg max-w-3xl mx-auto" data-id="element-182">
            Nail Masterclass Pro es la primera formación completa que combina
            técnicas profesionales, diseños virales y estrategias de negocio
            para que puedas transformar tu pasión en un emprendimiento rentable
            en tiempo récord.
          </p>
        </div>
        <div className="text-center mt-8" data-id="element-183">
          <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 inline-block" data-id="element-184">
            QUIERO COMENZAR AHORA - $14.999
          </a>
        </div>
      </div>
    </section>;
}